
          <template>

<v-img max-height="50px" :src="require('@/assets/SideBarBG.png')" gradient="to right, #ffffff 0%, #336699 100%">
<v-breadcrumbs :items="items" divider="-"></v-breadcrumbs>
</v-img>
</template>

<script>
import router from '@/router/index.js'
import { setTimeout } from 'timers'

export default {

    data() {
        return{
           items: [
        {
          text: 'Welcome',
          disabled: false,
          href: '/Welcome',
        },
      ],
      defaultitems: [
        {
          text: 'Welcome',
          disabled: false,
          href: '/Welcome',
        },
      ],
        }
    },


    watch:{
        '$route' (){
            this.GetNavigation()
        }
    },

    created() {
        this.GetNavigation()
    },
    methods: {

       GetNavigation: function (){
           console.log('it changed')

           this.items = Object.assign([],this.defaultitems)
          setTimeout(() => {

        let checkingurl = this.$route.path
         console.log(checkingurl)
           if(checkingurl === '/Users'){
               let NewItem = {
                   text: 'Users',
                    disabled: false,
                    href: '/Users',
               }
               this.items.push(NewItem)
           }
            else if(checkingurl === '/User/'+this.$route.params.id) {


            let NewItem = {
                   text: 'Users',
                    disabled: false,
                    href: '/Users',
               }
               this.items.push(NewItem)

             let NewItem2 = {
                   text: 'Current Record',
                    disabled: false,
                    href: '/User/'+this.$route.params.id,
               }
               this.items.push(NewItem2)
            }

        }, 500)
       }
       }
    }

</script>

<style>
.fixed {
position: fixed;
}
</style>
    